import http from '@/utils/http'

export function getAnswerResults(params){
    return  http('/adminAnswerResults',{params})
}

export function countAdminAnswerResults(params){
    return  http('/countAdminAnswerResults',{params})
}

export function getAnswerResultsDetail(id){
    return  http(`/adminAnswerResults/${id}`)
}

export function updateScore(params){
    return  http.post('/updateScore',params)
}